import { createLocale } from '../api/i18n/LocaleMap'

export interface I18nTextStore {
  getText: (key: string, format?: string | string[] | { [key: string]: string }) => string
  transformLang: (key: string) => string | undefined
  setLocaleMap: (map: any) => void
  getLocaleMap: () => { [key: string]: string }
}

export function I18nTextStore(localeMap: Record<string, any>): I18nTextStore {
  const locale = createLocale(localeMap)
  return {
    getText: (key: string, format?: string | string[] | { [key: string]: string }) => {
      return locale.getText(key, format)
    },
    transformLang: (key: string) => locale.transformLang(key),
    setLocaleMap: (map: any) => {
      locale.setLocaleMap(map)
    },
    getLocaleMap: () => {
      return locale.getLocaleMap()
    }
  }
}
